import styled from "styled-components";

const TableDataControl = styled.td`
    a { text-decoration: underline !important; }
`;

export default TableDataControl;